import { render, staticRenderFns } from "./DiningRoomList.vue?vue&type=template&id=46c63ea4&scoped=true"
import script from "./DiningRoomList.vue?vue&type=script&lang=js"
export * from "./DiningRoomList.vue?vue&type=script&lang=js"
import style0 from "./DiningRoomList.vue?vue&type=style&index=0&id=46c63ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c63ea4",
  null
  
)

export default component.exports